var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-modal",
    {
      attrs: {
        "modal-class": "scopes-update-wrapper vue-need-bootstrap",
        title: "Update Permissions",
        lazy: "",
        centered: "",
        "hide-footer": "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "hide-header-close": !_setup.canSkip,
      },
      on: { close: _setup.onSkipHandler },
      model: {
        value: _setup.isVisible,
        callback: function ($$v) {
          _setup.isVisible = $$v
        },
        expression: "isVisible",
      },
    },
    [
      _c("div", { staticClass: "content text-center" }, [
        _c("p", [
          _vm._v(
            "Due to new updates from Shopify, Customily requieres new permissions to sync and fulfill your orders."
          ),
        ]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_setup.storesToUpdate, function (store) {
            return _c("li", { key: store.name }, [
              _c(
                "a",
                { attrs: { href: store.updateUrl, rel: "update scopes url" } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(store.name) +
                      "\n                "
                  ),
                ]
              ),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary d-block mx-auto my-3",
            on: { click: _setup.onGrantHandler },
          },
          [_vm._v("Grant Permission")]
        ),
        _vm._v(" "),
        _setup.canSkip
          ? _c(
              "a",
              {
                staticClass: "skip-link",
                attrs: { href: "#" },
                on: { click: _setup.onSkipHandler },
              },
              [_vm._v("Skip for now")]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }